'use client'

// src/context/root/context.ts
import { createContext } from "react";
var context_default = createContext(null);

export {
  context_default
};
//# sourceMappingURL=chunk-DG2ER5TA.mjs.map